<div class="page-head page-head--custom">
    <app-back [locationBack]="true" (onBack)="onBack()"></app-back>
    <h1 class="title title--size-l text--center">{{guideExport.title}}</h1>
</div>
<div class="custom-gas-price page-row page-content">
    <div class="content-center guides">
        <h2 class="text text--center">{{guideExport.description}}</h2>

        <div class="mt-24 slide-container content-center">
            <ng-container *ngFor="let item of guideItems.elementSlide">
                <img src="{{item.image}}" alt="" class="slide" [ngClass]="{'active': item.active }">
            </ng-container>
        </div>

        <div class="mt-16 mb-16 content-arrow">
            <button [disabled]="!(guideItems.current - 1 >= 0)" class="btn-arrow arrow-left" (click)="onLeft()">
                <app-arrow-down>
                </app-arrow-down>
            </button>

            <div class="counter">
                <p class="text text--color-secondary">
                    {{guideItems.current + 1}} / {{guideItems.maxSlide}}
                </p>
            </div>
            <button [disabled]="!(guideItems.current + 1 < guideItems.maxSlide)" class="btn-arrow arrow-right"
                (click)="onRight()">
                <app-arrow-down>
                </app-arrow-down>
            </button>

        </div>

        <div class="content-center">
            <p class="text">
                {{guideItems.description}}
            </p>
        </div>
    </div>
</div>